import React from "react";
import SingleSelectDropdown from "../../../select/base/SingleSelectDropdown";
import { REPORT_BY_GROUP_OPTIONS } from "../../../../../util";

const ReportGroupSelect = ({ selectedValue, setSelectedValue }) => {
  return (
    <SingleSelectDropdown
      title="app.group"
      values={REPORT_BY_GROUP_OPTIONS}
      onChange={setSelectedValue}
      defaultSelected={null}
      emptyMessage="app.no.options"
    />
  );
};

export default ReportGroupSelect;
